import { defineChain } from 'viem';

import { getContrastColor } from '@infinex/ui-utils/color';

import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

const viemMegaeth = /*#__PURE__*/ defineChain({
  id: 4326,
  name: 'MegaETH',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 9248132,
    },
  },
  rpcUrls: {
    default: { http: ['https://rpc.megaeth.xyz'] },
  },
  blockExplorers: {
    default: {
      name: 'MegaETH Explorer',
      url: 'https://megaeth.blockscout.com/',
    },
  },
  testnet: false,
});

export const megaeth = {
  displayName: 'MegaETH',
  isSupported: true,
  isMainnet: true,
  isReleased: true,
  runtime: 'evm',
  orderPriority: 3,
  decoration: {
    color: '#ECE8E8',
    get contrastColor() {
      return getContrastColor(this.color);
    },
  },
  viemChain: viemMegaeth,
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'megaeth-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://megaeth.blockscout.com',
        token: 'https://megaeth.blockscout.com/token',
      },
    },
  },
  environments: defaultEnvironments({
    dev: true,
    test: true,
    staging: true,
    prod: true,
  }),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '100000031',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    across: { chainKey: 'megaeth' },
    kyberswap: { chainKey: 'megaeth' },
    lifi: { chainKey: 'MEG' },
    stargate: { chainKey: 'megaeth' },
    xswap: { chainKey: '4326' },
  }),
  services: defaultServices({
    codex: {
      networkId: 4326,
      nativeLiquidityAddress: '0x4200000000000000000000000000000000000006',
    },
    // trm: { chainKey: 'monad' },
    coingecko: {
      networkId: 'megaeth',
      platformId: 'megaeth',
    },
    // coingeckoDex: {
    //   networkId: undefined,
    // },
    zerion: {
      chainKey: 'megaeth',
    },
    qnStreams: {
      networkKey: 'megaeth-mainnet',
    },
    // STS URL path is `mega` (not Config API shortName `megaeth`).
    safe: { shortName: 'mega' },
    alchemy: { chainSlug: 'megaeth-mainnet' },
    pimlico: { chainSlug: 'megaeth' },
  }),
  limits: DEFAULT_CHAIN_LIMITS,
} as const satisfies AllChainConfig<'evm', true>;
